import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
import { convertMoneyToMinorUnits, formatMoney } from '@theme/money-formatting';

/**
 * Keeps the Shop page's mobile sticky checkout bar (total, item count, and
 * visibility) in sync with cart state from any source: the flavour cards'
 * add/quantity controls, the cart drawer, or another tab.
 *
 * @extends {Component}
 */
export class SpdStickyBarComponent extends Component {
  requiredRefs = ['total', 'count'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
  }

  /** @param {Event & {promise?: Promise<any>}} event */
  #onCartUpdate = (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        const itemCount = cart?.totalQuantity ?? detail?.itemCount ?? 0;

        this.hidden = itemCount === 0;
        this.refs.count.textContent = `${itemCount} item${itemCount !== 1 ? 's' : ''}`;

        const totalAmount = cart?.cost?.totalAmount;
        if (!totalAmount) return;

        const minorUnits = convertMoneyToMinorUnits(totalAmount.amount, totalAmount.currencyCode);
        if (minorUnits === null) return;

        this.refs.total.textContent = formatMoney(
          minorUnits,
          this.dataset.moneyFormat || '{{amount}}',
          totalAmount.currencyCode
        );
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[spd-sticky-bar] Cart sync failed:', error);
      });
  };
}

if (!customElements.get('spd-sticky-bar-component')) {
  customElements.define('spd-sticky-bar-component', SpdStickyBarComponent);
}
